import BorderedIcon from "components/BorderedIcon";
import ColumnRow, {
  columnRowTypeNames,
} from "components/pages/contentSections/ColumnRow";
import SplitText from "mono/components/SplitText";
import { TransitionLink } from "mono/components/TransitionLink";
import styled from "styled-components";
import WhatWeDoServiceHeader from "../WhatWeDoHeader";

export default function WhatWeDoServiceCampaign() {
  return (
    <Wrapper>
      <WhatWeDoServiceHeader
        service="Campaigns"
        fitTextHeader={{
          singleLine: true,
          parentFitMode: "width",
        }}
      >
        <div>
          <SplitText tag="p" animateOnScroll>
            Bij Nine ontwikkelen we creatieve marketingcampagnes die opvallen,
            raken en resultaat opleveren. Met een sterke strategie,
            onderscheidende concepten en doelgerichte uitvoering vergroten we
            jouw zichtbaarheid, versterken we je merk en zorgen we voor meetbaar
            succes. Geen losse ideeën, maar campagnes die de juiste snaar raken
            en jouw doelen dichterbij brengen.
          </SplitText>
          <SplitText tag="p" animateOnScroll>
            Zo laten we jouw merk niet alleen opvallen, maar écht impact maken.
          </SplitText>
        </div>

        <TransitionLink href="/service/campaigns">
          <BorderedIcon text={"More about <strong>campaigns</strong>"} />
        </TransitionLink>
      </WhatWeDoServiceHeader>

      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/campaigns.jpeg",
              },
              width: 100,
            },
          ],
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .icon-container {
    margin-top: 150rem;
  }
  margin-bottom: 150rem;
`;
